<template>
  <v-dialog
    v-model="showInfoDetail"
    max-width="60%"
  >
    <v-card outlined class="py-2">
      <v-card-title>
        <v-chip class="mx-2" color="red" text-color="white" v-if="information.Type == '障害発生'">{{ information.Type }}</v-chip>
        <v-chip class="mx-2" color="light-blue" text-color="white" v-else-if="information.Type == '障害復旧'">{{ information.Type }}</v-chip>
        <v-chip class="mx-2" color="red" text-color="white" v-else-if="information.Type == '重要なお知らせ'">{{ information.Type }}</v-chip>
        <v-chip class="mx-2" color="green" text-color="white" v-else>{{ information.Type }}</v-chip>
          <span class="title" v-html="information.Message"></span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col dense cols="12" class="pa-0 mb-0">
            <div class="caption ml-4">{{ information.NoticeFrom }}</div>
            <div class="ml-4" v-html="information.Detail"></div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { getInformation } from '../graphql/queries'

export default {
  name: 'informationDetail',
  data() {
    return {
      showInfoDetail: false,
      information: {},
    }
  },
  mounted: async function () {
  },
  computed : {
  },
  methods: {
    open: async function(id, order) {
      console.log("open Information detail", id + "[" + order +"]")
      let information = await API.graphql(graphqlOperation(getInformation, {id: id, Order: order}))
      this.information = information.data.getInformation
      console.log("information", information)
      this.showInfoDetail = true;
    },
    close() {
      this.showInfoDetail = false;
    }
  },
}
</script>